import { Pipe, PipeTransform } from '@angular/core';

interface Categorizable {
  categories?: string[];
}

@Pipe({
  name: 'categoryFilter'
})
export class CategoryFilterPipe implements PipeTransform {
  transform(items: Categorizable[] = [], categories: string[]): Categorizable[] {
    if (!categories.length) {
      return items;
    }

    return items.filter((item) => {
      // if (!item.categories.length) { return true; } // Always show items without categories?
      return categories.some((category) => item.categories.includes(category));
    });
  }
}
